import { Component, Input } from '@angular/core';
import { PaginatorState } from 'primeng/paginator';
import { TableColumn } from '../../interfaces/table.interface';

@Component({
  selector: 'app-dashboard-dialog',
  templateUrl: './dashboard-dialog.component.html',
  styleUrl: './dashboard-dialog.component.scss',
  standalone: false
})
export class DashboardDialogComponent {
  // Dialogo
  @Input() visible = false;
  @Input() title = '';
  @Input() onClose!: () => void;

  // Tabla
  @Input() column: TableColumn[] = [];
  @Input() data: any[] = [];

  first: number = 0;
  rows: number = 10;

  stateTag(value: string): 'success' | 'warn' | 'info' {
    // Cambia el color del tag dependiendo el estado de la solicitud
    switch (value?.toLowerCase()) {
      case 'abierto': return 'warn';
      case 'cerrado': return 'success';
      default: return 'info';
    }
  }

  // Paginación
  onPageChange(event: PaginatorState) {
    this.first = event.first ?? 0;
    this.rows = event.rows ?? 10;
  }

}
